import dayjs from 'dayjs';
import { classApi } from '@/api';

const dayWeek = ['日', '一', '二', '三', '四', '五', '六'];

export default {
  filters: {
    courseStatus(row) {
      if (row.sign_up_status === 3) {
        // 报名结束的展示上课状态
        return row.class_phase_label;
      }
      return row.sign_up_status_label;
    }
  },
  methods: {
    classPeriodic(value) {
      if (!value) return '无';
      const arr = value.split(',').filter(key => (key !== '' ? key : false));
      if (arr[0] === '0') {
        arr.shift();
        arr.push(0);
      }
      return arr.map(key => dayWeek[key]).join('，');
    },
    classTimeSp(row) {
      let str = '无';
      if (!row.first_class_start_time || !row.last_class_end_time) return str;
      if (row.class_mode === 3) {
        if (!Array.isArray(row.mode_class_time) || row.mode_class_time[0].length !== 3) return str;
        str = row.mode_class_time
          .map(
            item =>
              `星期${dayWeek[dayjs(item[0]).day()]} <span style="color: #3a8ee6">${dayjs(item[0]).format('HH:mm')}-${dayjs(
                item[1]
              ).format('HH:mm')}</span> ${item[2]}`
          )
          .join('<br />');
      } else {
        str = `星期${this.classPeriodic(row.class_periodic)} <span style="color: #3a8ee6">${dayjs(
          row.first_class_start_time
        ).format('HH:mm')} - ${dayjs(row.last_class_end_time).format('HH:mm')}</span> ${
          Array.isArray(row.classroom) ? row.classroom[0] : ''
        }`;
      }
      return str;
    },
    getHdEnum(classInfTable) {
      if (this.tableHeader.length) {
        this.search();
        return;
      }
      Promise.all([
        classApi.publishStatus(),
        classApi.signUpStatus(),
        classApi.classPhase()
      ]).then(values => {
        this.tableHeader = classInfTable.map(item => {
          const tmp = item;
          if (tmp.value === 'publish_status') {
            tmp.headerSlot.select = values[0].data;
          }
          if (tmp.value === 'sign_up_status') {
            tmp.headerSlot.select = values[1].data;
          }
          if (tmp.value === 'class_phase') {
            tmp.headerSlot.select = values[2].data;
          }
          return tmp;
        });
        this.$nextTick(() => {
          if (this.$refs[this.keyId]) this.$refs[this.keyId].init();
          this.search();
        });
      });
    }
  }
};
